import ApiService from '@/services/core/api.service'

const LeadTagService = {
  async get (query) {
    return ApiService.get(`admin/lead-tags?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/lead-tags', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/lead-tags/${payload.id}`, payload)
  }
}

export default LeadTagService
